import { useState } from "react";
import { X } from "lucide-react";

import * as Api from "@modules/api";
import { Modal } from "@components/items/display/Modal";

import { Products } from "./Products";
import { Success } from "./Success";
import { Checkout } from "./Checkout";
import { PlanActions } from "@lib/fetchers/plans";

interface SubscriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const SubscriptionModal = ({
  isOpen,
  onClose,
}: SubscriptionModalProps) => {
  const [selectedProduct, setSelectedProduct] = useState<
    Api.Server.ProductGroupProductOutput | undefined
  >();
  const [promoCode, setPromoCode] = useState<string | undefined>(undefined);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSuccessLoading, setIsSuccessLoading] = useState(false);

  const onSubscriptionClose = () => {
    onClose();

    if (isSuccess) {
      window.location.reload();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onSubscriptionClose}
      zIndexClassName="z-[70]"
      contentClassName={`${selectedProduct ? "w-[93%]" : "w-[37%]"} min-w-[512px] h-[80%] cus-scrollbar-w-none`}
    >
      <div className="relative">
        <div
          className="absolute -top-[9px] flex h-[45px] w-[45px] cursor-pointer items-center justify-center rounded-full bg-[#00000040] text-black ltr:-right-[9px] rtl:-left-[9px] dark:bg-[#FFFFFF40] dark:text-white"
          onClick={onSubscriptionClose}
        >
          <X size={20} strokeWidth={2.5} />
        </div>
        {!selectedProduct ? (
          <Products
            onProductSelect={(product, promoCode) => {
              setSelectedProduct(product);
              setPromoCode(promoCode);
            }}
          />
        ) : !isSuccess ? (
          <Checkout
            product={selectedProduct}
            promoCode={promoCode}
            onCancel={() => {
              setSelectedProduct(undefined);
            }}
            onSuccess={async () => {
              setIsSuccess(true);
              setIsSuccessLoading(true);

              setTimeout(async () => {
                await PlanActions.getMyPlansAsync();

                setIsSuccessLoading(false);
              }, 7000);
            }}
          />
        ) : (
          <Success
            onSubmit={onSubscriptionClose}
            isLoading={isSuccessLoading}
          />
        )}
      </div>
    </Modal>
  );
};
